import React from "react";
import PropTypes from "prop-types";
import BillCard from "../BillCard/BillCard";
import "./BillList.css";
import { Button, Grid, Stack, Typography, Box } from "@mui/joy";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const BillList = ({
  bills,
  loading,
  hasMore,
  searchParams,
  onClearSearch,
  isStateBills = false,
}) => {
  return (
    <Stack
      direction="column"
      spacing={4}
      sx={{
        alignItems: "center",
        padding: { xs: "2rem 1.25rem", md: "2.5rem 2rem" },
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, md: 2.5 }}
        columns={{ xs: 1, sm: 2, md: 3 }}
        sx={{ maxWidth: "1200px", width: "100%" }}
      >
        {bills?.map((bill, index) => (
          <Grid key={index} xs={1} sx={{ display: "flex" }}>
            <BillCard bill={bill} isStateBill={isStateBills} />
          </Grid>
        ))}
      </Grid>

      {!loading && bills.length === 0 && searchParams?.keyword && (
        <Stack spacing={2} sx={{ py: 8, alignItems: "center", maxWidth: 480 }}>
          <SearchOffIcon sx={{ fontSize: 48, color: "rgba(255,255,255,0.4)" }} />
          <Typography level="title-md" sx={{ color: "white", fontWeight: 600 }}>
            No bills found
          </Typography>
          <Typography
            level="body-md"
            sx={{ textAlign: "center", color: "rgba(255,255,255,0.75)", lineHeight: 1.6 }}
          >
            No results for &ldquo;{searchParams.keyword}&rdquo;. Try different keywords or browse all legislation.
          </Typography>
          <Button
            variant="outlined"
            size="md"
            onClick={onClearSearch}
            sx={{
              borderColor: "rgba(255,255,255,0.3)",
              color: "white",
              backgroundColor: "transparent",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 600,
              paddingX: 3,
              transition: "border-color 0.15s ease, background-color 0.15s ease",
              "&:hover": {
                borderColor: "rgba(255,255,255,0.6)",
                backgroundColor: "rgba(255,255,255,0.08)",
              },
              "@media (prefers-reduced-motion: reduce)": { transition: "none" },
            }}
          >
            Clear search
          </Button>
        </Stack>
      )}

      {!loading && bills.length === 0 && !searchParams?.keyword && (
        <Stack spacing={2} sx={{ py: 8, alignItems: "center", maxWidth: 480 }}>
          <Typography level="title-md" sx={{ color: "white", fontWeight: 600 }}>
            No bills available
          </Typography>
          <Typography
            level="body-md"
            sx={{ textAlign: "center", color: "rgba(255,255,255,0.75)", lineHeight: 1.6 }}
          >
            There are currently no bills to display. Please check back later.
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

BillList.propTypes = {
  bills: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  searchParams: PropTypes.object.isRequired,
  onClearSearch: PropTypes.func.isRequired,
};

BillList.defaultProps = {
  loading: false,
  hasMore: true,
};

export default BillList;
